import React, { useEffect, useState } from "react";
import datastore from '../../store/hoa-datastore';

import OverView from './view/hoa-view-overview';
import MuncipalityFees from './view/hoa-muncipality-fees';
import AdditinalDetials from './view/hoa-additinal-details';
import HoaAppLog from "../hoa-app-log/hoa-app-log";

import dashboardServices from "../../services/hoa-dashboard-api-service";
import config from "../../hoa-config";

const changeLogTitle = 62;


export default function ViewComponent(props: any) {

	const { tabIndex, selectedValues, feesWarning, additionalInfoWarning } = props;

	const [isLogLoading, updateLogLoading] = useState(false);
	const [appLogs,setAppLogs] = useState({
        data:[],
        count: null,
        pageNumber:1,
        isLastPage:false,
    });
	const numberOfProjects = Math.ceil((window.innerHeight - datastore.responsiveHeight) / 60);

	const getCreatedLogs = async (page: number, options?: any) => {
		updateLogLoading(true);
		const {status, data} = await dashboardServices.getCreatedLogs(selectedValues.objectId, numberOfProjects, page, options);
		if(status == 200) {
			const { createdlogs, totalCount } = data;
			let isLastPage = [...appLogs.data, ...createdlogs].length >= totalCount
			datastore.createdLogs[selectedValues.objectId] = createdlogs;
			if(Object.values(options).length){
				let tempLogs = {...appLogs};
				tempLogs.data = createdlogs;
				tempLogs.pageNumber = 1;
				tempLogs.isLastPage = isLastPage;
				tempLogs.count = totalCount;
	
				datastore.createdLogs[selectedValues.objectId] = tempLogs;
				setAppLogs(tempLogs);
			}else{
				const mergedLogs = [...appLogs.data, ...createdlogs];
				const uniqueLogs = mergedLogs.filter(
					(log, index, self) =>
						index === self.findIndex((t) => t.objectId === log.objectId)
				);
				let tempLogs = {...appLogs};
				tempLogs.data = uniqueLogs;
				tempLogs.pageNumber = appLogs.pageNumber+1;
				tempLogs.isLastPage = isLastPage;
				tempLogs.count = totalCount;
	
				datastore.createdLogs[selectedValues.objectId] = tempLogs;
				setAppLogs(tempLogs);
			}
			updateLogLoading(false);
		}
	};

	useEffect(()=>{
		if(!datastore.createdLogs[selectedValues.objectId]) {
			getCreatedLogs(appLogs.pageNumber, {});
		} else {
			setAppLogs(datastore.createdLogs[selectedValues.objectId]);
		}
		return ()=>{
			setAppLogs({
				count: null,
				data: [],
				isLastPage: false,
				pageNumber: null
			})
		}
	},[selectedValues.objectId])

	const overViewdetails: any = {
		municipalityName: selectedValues['name'],
		overView: {
			'ID': selectedValues['objectId'],
			'Market': selectedValues['market'],
			'City': selectedValues['city'],
			'State': selectedValues['state'],
			'Zip': selectedValues['zip']?.split(","),
			'Phone Number' : selectedValues['phone'],
			'Email' : selectedValues['email'],
			'Fax' : selectedValues['fax'],
			'Website' : selectedValues['website'],
		},
		registrationResolutionForm : selectedValues['registrationResolutionForm'],
		ownerRenewalForm : selectedValues['ownerRenewalForm'],
		renewalInstructions: selectedValues['renewalInstructions'],
		registrationRequirements: selectedValues['registrationRequirements'],
		tenantLeaseRegistrationFormUrl: selectedValues['tenantLeaseRegistrationFormUrl'],
		countyOrMunicipalityRenewalForm : selectedValues['countyOrMunicipalityRenewalForm'],
		renewalFee: selectedValues?.fees ? selectedValues?.fees['renewalFee'] : '',
	}

	const fees = selectedValues['fees'] ? selectedValues['fees'] : {};
	const muncipalitesFees: any = {
		'rentalRegistration': {
			'Registration Fee': fees['registrationFee'] || '',
			'Landlord Registration Fee': fees['landLordRegistrationFee'] || '',
			'Registrations Admin Fee': fees['registrationAdminFee'] || '',
			'Registration Renewal Frequency': fees['renewalFrequency'] || '',
			'Landlord Registration Renewal Frequency': fees['landlordRenewalFrequency'] || '',
			'Registration Convenience Fee': fees['registrationConvenienceFee'] || '',
		},
		'renewalProcessingFee': fees['renewalProcessingFee'] || '',
		'renewalFee': fees['renewalFee'] || '',
		'applicationFee': fees['applicationFee'] || '',
		'stateMandateFee': fees['stateMandateFee'] || '',
		'penalty': fees['penalty'] || '',
		'residentialLandlordTaxSchedule': fees['residentialLandlordTaxSchedule'] || '',
	}

	const additionalInfo = selectedValues['additionalInfo'] ? selectedValues['additionalInfo'] : {};
	const additinalDetails: any = {
		'inspectionRequirement': {
			'Inspection Fee': additionalInfo['inspectionFee'] || '',
			'Re-Inspection Fee': additionalInfo['reInspectionFee'] || '',
			'Mandatory Inspection': additionalInfo['isInspectionMandatory'] || '',
			'Self Inspection Available': additionalInfo['iseSelfInspectionAvailable'] || '',
			'Inspection Schedule Method': additionalInfo['inspectionScheduleMethod'] || '',
		},
		'inspectionCriteria': {
			'exteriorInspection': additionalInfo['exteriorInspection'] || '',
			'interiorInspection': additionalInfo['interiorInspection'] || '',
		},
		'codeOfCompliance': {
			'isCodeOfComplianceRequired': additionalInfo['isCodeOfComplianceRequired'] || '',
			'commonCodeViolations': additionalInfo['commonCodeViolations'] || ''
		},
		'rentalCertificate': {
			'Is rental certificate of occupancy needed?': additionalInfo['isRentalCertificateNeeded'] || '',
			'Are outstanding tax payments allowed?': additionalInfo['isOutstandingTaxPaymentAllowed'] || '',
			'Are outstanding violations/payments allowed?': additionalInfo['isOutstandingViolationAllowed'] || '',
			'Is there Pre-Occupancy Penalty for occupation of property before obtaining Rental Certificate of Occupancy?': additionalInfo['preOccupencyPenalty'] || '',
			'Is it required to have local agent as contact?': additionalInfo['isLocalAgentRequired'] || '',
		}
	}

	return (
		<div
			style={{
				height: window.innerHeight - datastore.responsiveHeightWithtab,
				overflow: "scroll",
				background: "white",
			}}
		>
			{
				tabIndex === 0 && <OverView details={overViewdetails} />
			}
			{
				tabIndex === 1 && datastore.userRole != config.userRoles.OrganizationUser &&
				<>
					{
						!feesWarning ?
							<MuncipalityFees details={muncipalitesFees} /> :
							<NoDataAvailable
								title='No Details  Added Yet'
								subTitle='Please add Municipality details to complete the Municipality information.'
							/>
					}
				</>
			}
			{
				tabIndex === 2 && datastore.userRole != config.userRoles.OrganizationUser &&
				<>
					{
						!additionalInfoWarning ?
							<AdditinalDetials details={additinalDetails} /> :
							<NoDataAvailable
								title='No Details  Added Yet'
								subTitle='Please add additional details to complete the Municipality information.'
							/>
					}
				</>
			}
			{
				tabIndex === 3 && datastore.userRole != config.userRoles.OrganizationUser &&
					<HoaAppLog type={"Municipality"} isLogLoading={isLogLoading} updateLogLoading={updateLogLoading} appLogs={appLogs} setAppLogs={setAppLogs} getAssignedLogs={getCreatedLogs} height= {window.innerHeight - (datastore.responsiveHeight+changeLogTitle)} />
			}
		</div>
	);
}


export const NoDataAvailable = (props: any) => {
	const { title, subTitle } = props;
	return (
		<div
			style={{
				height: '100%',
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				alignItems: "center",
			}}
		>
			<img
				style={{ width: "200px", height: "200px" }}
				src="images/logo/no-wallpaper.png"
			/>
			<span style={{ marginTop: '12px' }} className="text-787878-24px">{title}</span>
			<span style={{ marginTop: '10px' }} className="text-787878-16px">{subTitle}</span>
		</div>
	);
};